'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresOmalomaContactForm = function () {
  function WinresOmalomaContactForm($scope, $rootScope, omalomaService) {
    _classCallCheck(this, WinresOmalomaContactForm);

    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.omalomaService = omalomaService;

    // Current status. Possible values:
    // init - Initializing.
    // out - Not logged in.
    // loading - Loading info.
    // ready - Info loaded. Possibly just saved.
    // saving - Saving changes.
    // failure - Cannot display information. Note: a load error will cause this, a save error will not.
    //           In case of save error, state is set to 'ready' and the user can try again.
    //
    // The other two values are a notice to display, and an error to display.
    // Neither, one, or both may be set.
    // The values, if non-null, are passed to i18next.
    this.setStatus('init', null, null);
  }

  _createClass(WinresOmalomaContactForm, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.$rootScope.$on('login', function () {
        return _this.load();
      });
      this.$rootScope.$on('logout', function () {
        _this.reset();
        _this.setStatus('out', null, null);
      });

      if (this.omalomaService.isLoggedInAsCustomer()) {
        this.load();
      } else {
        this.setStatus('out', null, null);
      }
    }
  }, {
    key: 'load',
    value: function load() {
      var _this2 = this;

      this.reset();
      this.setStatus('loading', undefined, null);
      this.omalomaService.getCustomerInfo().then(function (customer) {
        _this2.$scope.customer = customer;
        console.log("[WOCE] Got customer info: ", customer);
        _this2.$scope.originalEmail = customer.EmailAddress;
        _this2.setStatus('ready', undefined, null);
        setTimeout(function () {
          document.querySelectorAll('input[name="contactFormPhone"]')[0]['value'] = _this2.$scope.customer.PhoneNumber;
          document.querySelectorAll('input[name="contactFormEmail"]')[0]['value'] = _this2.$scope.customer.EmailAddress;
        }, 1000);
      }).catch(function (error) {
        console.error('[WOCE] Failed to get customer info:', error);
        _this2.setStatus('error', undefined, 'load_failure');
      });
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.$scope.customer = null;
      this.$scope.originalEmail = null;
      this.$scope.emailConfirm = '';
      this.$scope.privacyPolicyURL = '#';
    }
  }, {
    key: 'setStatus',
    value: function setStatus(status, notice, error) {
      if (status !== undefined) {
        console.log('[WOCE] Set status to', status);
        this.$scope.status = status;
      }
      if (notice !== undefined) {
        if (notice) console.log('[WOCE] Notice:', notice);
        this.$scope.notice = notice;
      }
      if (error !== undefined) {
        if (error) console.log('[WOCE] Error:', error);
        this.$scope.error = error;
      }
    }
  }, {
    key: 'sendAgain',
    value: function sendAgain() {
      if (this.omalomaService.isLoggedInAsCustomer()) {
        this.load();
      } else {
        this.setStatus('out', null, null);
      }
    }
  }, {
    key: 'sendContactForm',
    value: function sendContactForm() {
      var _this3 = this;

      this.omalomaService.getOfficeSiteParameters(this.$rootScope.winresConnectionName).then(function (response) {
        console.log(response);
        var replaceObj = {
          message: _this3.contactFormMessage || '',
          phoneNumber: _this3.$scope.customer.PhoneNumber,
          email: _this3.$scope.customer.EmailAddress,
          contactViaEmail: _this3.contactFormEmail ? 'Kyllä' : 'Ei',
          contactViaPhone: _this3.contactFormPhone ? 'Kyllä' : 'Ei',
          firstName: _this3.$scope.customer.FirstName,
          lastName: _this3.$scope.customer.LastName,
          address: _this3.$scope.customer.StreetAddress + ', ' + _this3.$scope.customer.PostalNumber + ' ' + _this3.$scope.customer.PostalAddress,
          bookingNumber: _this3.bookingNumber
        };

        var htmlEmailBody = require('./winresOmalomaContactFomrBody.html').replace('{{message}}', replaceObj.message).replace('{{phoneNumber}}', replaceObj.phoneNumber).replace('{{email}}', replaceObj.email).replace('{{firstName}}', replaceObj.firstName).replace('{{lastName}}', replaceObj.lastName).replace('{{address}}', replaceObj.address).replace('{{contactViaEmail}}', replaceObj.contactViaEmail).replace('{{contactViaPhone}}', replaceObj.contactViaPhone).replace('{{bookingNumber}}', replaceObj.bookingNumber);

        var sendObj = {
          FromAddress: _this3.$scope.customer.EmailAddress,
          ToAddress: response.Office.EmailAddress,
          Subject: 'Yhteydenotto',
          Message: htmlEmailBody,
          BookingNumber: _this3.bookingNumber
        };

        _this3.omalomaService.sendCustomerContactFormEmail(sendObj).then(function (response) {
          if (response) {
            _this3.setStatus('emailSent', undefined, null);
          }
        });
      });
    }
  }]);

  return WinresOmalomaContactForm;
}();

WinresOmalomaContactForm.$inject = ['$scope', '$rootScope', 'omalomaService'];

_module3.default.component('winresOmalomaContactForm', {
  template: require('./winresOmalomaContactForm.html'),
  controller: WinresOmalomaContactForm,
  bindings: {
    bookingNumber: '<'
  },
  require: {}
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresOmalomaContactForm/winresOmalomaContactForm.js
// module id = 334
// module chunks = 2